export default function(msg: string) {
    return `say ${msg}`
}